import {
  Delivery,
  RecentLocationByDelivery,
  RecentLocationContentByDelivery,
} from "../../../types/delivery/delivery";
import {
  DeliveryDto,
  RecentLocationByDeliveryDto,
  RecentLocationContentByDeliveryDto,
} from "../../../types/delivery/delivery-dto";
import { DeliveryStatus } from "../../../types/delivery/delivery-status";
import { convertActionDtoToAction } from "../action/action-converter";
import { convertLoadDtoToLoad } from "../load/load-converter";
import { convertLocationDtoToLocation } from "../location/location-converter";
import { convertCompanyDtoToCompany } from "../user/company-convertor";
import { convertUserDtoToUser } from "../user/user-converter";
import { convertWorkPlaceDtoToWorkPlace } from "../work-place/work-place-converter";

export const convertDeliveryDtoToDelivery = (
  deliveryDto: DeliveryDto
): Delivery => {
  return {
    id: deliveryDto.id,
    client: convertCompanyDtoToCompany(deliveryDto.client),
    agency: convertCompanyDtoToCompany(deliveryDto.agency),
    pickUpLocation: convertLocationDtoToLocation(deliveryDto.pickUpLocation),
    pickUpAction: convertActionDtoToAction(deliveryDto.pickUpAction),
    dropOffLocation: convertLocationDtoToLocation(deliveryDto.dropOffLocation),
    dropOffAction: convertActionDtoToAction(deliveryDto.dropOffAction),
    pickUpWorkPlace: convertWorkPlaceDtoToWorkPlace(
      deliveryDto.pickUpWorkPlace
    ),
    dropOffWorkPlace: convertWorkPlaceDtoToWorkPlace(
      deliveryDto.dropOffWorkPlace
    ),
    load: convertLoadDtoToLoad(deliveryDto.load),
    dateToWork: deliveryDto.dateToWork,
    status: deliveryDto.status,
    scheduleId: deliveryDto.scheduleId,
    worker: deliveryDto.worker
      ? convertUserDtoToUser(deliveryDto.worker)
      : undefined,
    comment: deliveryDto.comment,
    invoiceNumber: deliveryDto.invoiceNumber,

    pickUpDisabled: getPickUpDisabled(deliveryDto),
    dropOffDisabled: getDropOffDisabled(deliveryDto),
    disabled: false,
  };
};

export const convertRecentLocationContentByDeliveryDtoToRecentLocationContentByDelivery =
  (
    recentLocationContentByDeliveryDto: RecentLocationContentByDeliveryDto
  ): RecentLocationContentByDelivery => {
    return {
      workPlace: convertWorkPlaceDtoToWorkPlace(
        recentLocationContentByDeliveryDto.workPlace
      ),
      roadAddress: recentLocationContentByDeliveryDto.roadAddress,
      jibunAddress: recentLocationContentByDeliveryDto.jibunAddress,
      dateToWork: recentLocationContentByDeliveryDto.dateToWork,
    };
  };

export const convertRecentLocationByDeliveryDtoToRecentLocationByDelivery = (
  recentLocationByDeliveryDto: RecentLocationByDeliveryDto
): RecentLocationByDelivery => {
  return {
    totalElements: recentLocationByDeliveryDto.totalElements,
    contents: recentLocationByDeliveryDto.contents.map(
      (recentLocationContentByDeliveryDto) =>
        convertRecentLocationContentByDeliveryDtoToRecentLocationContentByDelivery(
          recentLocationContentByDeliveryDto
        )
    ),
  };
};

const getPickUpDisabled = (deliveryDto: DeliveryDto) => {
  return [
    DeliveryStatus.PickUp,
    DeliveryStatus.Ship,
    DeliveryStatus.DropOff,
  ].includes(deliveryDto.status);
};

const getDropOffDisabled = (deliveryDto: DeliveryDto) => {
  return [DeliveryStatus.DropOff].includes(deliveryDto.status);
};
